<template>
  <div class="local-priority">
    <h1 v-if="title"
        class="local-priority-title">{{$t('message.settings.message.campaignsPriority')}}</h1>

    <draggable v-model="list"
               :disabled="!drag"
               class="local-priority-list"
               group="localPriority"
               draggable=".drag"
               @end="emitEnd">
      <locale-priority-item v-for="(item, index) in list"
                            :class="`${prioritizeAdvertizer && index===0 ? 'not-drag' : 'drag'}`"
                            :item="item"
                            :key="index"
                            :currentLevel="currentLevel"
                            @click="$emit('setLevel', $event)" />
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import LocalePriorityItem from "./LocalePriorityItem.vue";

export default {
  components: {
    LocalePriorityItem,
    draggable,
  },

  data() {
    return {
      list: this.initialList,
    };
  },

  props: {
    initialList: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: Boolean,
      default: false,
    },
    drag: {
      type: Boolean,
      default: false,
    },
    currentLevel: {
      type: Number,
      default: 0,
    },
  },

  mixins: [],

  computed: {
    prioritizeAdvertizer() {
      return this.$store.state.users.user.permissions["PRIORIZAR_ANUNCIANTE"];
    },
  },

  methods: {
    emitEnd() {
      this.$emit("end", this.list);
    },
  },
};
</script>

<style lang="scss" scoped>
.local-priority {
  .local-priority-title {
    font-size: 28px;
    text-align: center;
    color: #cecfd0;
  }

  .local-priority-list {
    display: flex;
    justify-content: center;

    .local-priority-item {
      flex: 0 1 content;
    }
  }
}
</style>
